import { api } from "@/builders/axios";
import {
  CreateDepartmentData,
  DepartmentList,
} from "@/builders/types/department";
import { FilterParams } from "@/builders/types/filter-params";

import { id } from "./id";

const get = function (
  params?: FilterParams<{
    group?: number | string;
  }>
) {
  return api
    .get<DepartmentList>("departments", { params })
    .then(({ data }) => data);
};

const post = function (data: CreateDepartmentData) {
  return api.post("departments", data).then(({ data }) => data);
};

export const departments = {
  get,
  post,
  id,
};
